/**
 * /docs 文档系统导航配置（产品文档 + 使用文档，按用户旅程组织）
 *
 * 受众是产品使用者（求职者 / 评标专家），不是开发者：
 * - 快速开始 → 产品介绍 → 使用指南 → FAQ / 性能与可靠性
 * - 语言红线：除「性能与可靠性」小节外禁止技术名词（框架 / 中间件 / 协议名）
 *
 * markdown 正文存放在 src/docs/content/*.md，由 DocsView 通过
 * import.meta.glob('/src/docs/content/*.md', { as: 'raw' }) 按需加载。
 *
 * section.key 用于路由 /docs/:section/:page 的第一段，page.key 同时是
 * markdown 文件名（不含 .md）。新增文档：加 md 文件 + 在此登记。
 */

export interface DocPage {
  /** markdown 文件名（不含 .md，位于 src/docs/content/） */
  key: string;
  /** 左侧导航显示名 */
  title: string;
}

export interface DocSection {
  /** 分组 key（路由第一段） */
  key: string;
  /** 分组标题（左导航 section 标题） */
  title: string;
  pages: DocPage[];
}

export const DOC_SECTIONS: DocSection[] = [
  {
    key: 'start',
    title: '快速开始',
    pages: [
      { key: 'quick-start', title: '3 分钟上手' },
    ],
  },
  {
    key: 'jobfit',
    title: '招聘智能分析',
    pages: [
      { key: 'jobfit-intro', title: '产品介绍' },
      { key: 'jobfit-guide', title: '使用指南' },
    ],
  },
  {
    key: 'docsage',
    title: 'DocSage 文档智能体',
    pages: [
      { key: 'docsage-intro', title: '产品介绍' },
      { key: 'docsage-guide', title: '使用指南' },
    ],
  },
  {
    key: 'more',
    title: '了解更多',
    pages: [
      { key: 'faq', title: '常见问题' },
      { key: 'highlights', title: '性能与可靠性' },
    ],
  },
];

/** /docs 裸路径的重定向目标（第一个 section 的第一篇） */
export const DOCS_ENTRY = `/docs/${DOC_SECTIONS[0].key}/${DOC_SECTIONS[0].pages[0].key}`;

/** 按 key 查找 section / page */
export function findDocSection(sectionKey: string): DocSection | undefined {
  return DOC_SECTIONS.find((section) => section.key === sectionKey);
}

export function findDocPage(section: DocSection | undefined, pageKey: string): DocPage | undefined {
  return section?.pages.find((page) => page.key === pageKey);
}
